var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('error-layout',{attrs:{"title":_vm.i18nContent.title,"text":_vm.i18nContent.text}})}
var staticRenderFns = []

export { render, staticRenderFns }